import Vue from "vue"

export class AppManager {
  constructor() {
    this._vm = new Vue({
      data() {
        return {
          title: false,
          drawer: false,

          isLoadingPage: false,
          needLoginRedirect: false,
          isSessionExpired: false,

          shoppingCartLength: 0,

          isIntl: false,

          id_mappa_update: false,
          titlenews: false,
          contentnews: false,
          shownews: false
        }
      },
    })
  }

  setTitle(value) {
    this._vm.$data.title = value
  }

  get title() {
    return this._vm.$data.title
  }

  setIsIntl(value) {
    this._vm.$data.isIntl = value
  }

  get isIntl() {
    return this._vm.$data.isIntl
  }

  setIsLoadingPage(value) {
    this._vm.$data.isLoadingPage = value
  }

  get isLoadingPage() {
    return this._vm.$data.isLoadingPage
  }

  async setNeedLoginRedirect(value) {
    this._vm.$data.needLoginRedirect = value
  }

  get needLoginRedirect() {
    return this._vm.$data.needLoginRedirect
  }

  toggleDrawer() {
    this._vm.$data.drawer = !this._vm.$data.drawer
  }

  get drawer() {
    return this._vm.$data.drawer
  }

  setIsSessionExpired(message) {
    message = message || "Sua sessão expirou, por favor, faça o login novamente "
    this._vm.$data.isSessionExpired = {"message": message}
  }

  get isSessionExpired() {
    return this._vm.$data.isSessionExpired
  }

  setShoppingCartLength(value) {
    this._vm.$data.shoppingCartLength =value
  }

  get shoppingCartLength() {
    return this._vm.$data.shoppingCartLength
  }

  setTitleNews(value) {
    this._vm.$data.titlenews = value
  }

  get titleNews() {
    return this._vm.$data.titlenews
  }

  setContentNews(value) {
    this._vm.$data.contentnews = value
  }

  get contentNews() {
    return this._vm.$data.contentnews
  }  

  setShowNews(value) {
    this._vm.$data.shownews = value
  }

  get showNews() {
    return this._vm.$data.shownews
  } 

  setIdNews(value) {
    this._vm.$data.id_mappa_update = value
  }

  get idNews() {
    return this._vm.$data.id_mappa_update
  } 
  
}

export default () => {
  return new AppManager()
}
